import axios from 'axios'

axios.interceptors.request.use(function(config) {
        return config
    },
    function(error) {
        return Promise.reject(error)
    });

axios.interceptors.response.use(function(response) {

    if (response.status == 200) {
        return response.data;
    } else {
        return Promise.reject(response.data)
    }
});
//重点
export default function(method, url, data = '', token = '', headers) {
    method = method.toLowerCase();
    if (method === 'post' && !headers) {
        //console.log(11)
        return axios.post(url, data, {
            headers: {
                'token': token,
            }
        })
    } else if (method === 'post' && headers) {
        //console.log(22)
        return axios.post(url, data, {
            headers: Object.assign(headers, {
                'token': token,

            })
        })
    } else if (method === 'get') {
        return axios.get(url, {
            headers: {
                'token': token,
            },
            params: data,
        })
    } else if (axios === 'delete') {
        return axios.delete(url, { params: data })
    } else if (axios === 'put') {
        return axios.put(url, data)
    } else {
        //console.log('未知的method' + method)
        return false
    }
}


// WEBPACK FOOTER //
// ./src/service/http.js